import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "device-reading-agent app-page app-page--fill" }
const _hoisted_2 = { class: "agent-panel" }
const _hoisted_3 = { class: "toolbar" }
const _hoisted_4 = { class: "toolbar-actions" }
const _hoisted_5 = { class: "pagination-bar" }

import { reactive, ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Delete, Edit, Plus, Refresh, Search } from '@element-plus/icons-vue'
import DeviceReadingAgentApi, { type DeviceReadingAgentItem } from '@/network/apis/DeviceReadingAgent'
import { useRouteTitle } from '@/utils/useRouteTitle'
import { useButtonPermission } from '@/utils/buttonPermission'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

useRouteTitle('设备读数智能体')
const { can, canAny } = useButtonPermission('/visualModel/DeviceReadingAgent/index.vue')

const loading = ref(false)
const saving = ref(false)
const tableData = ref<DeviceReadingAgentItem[]>([])
const searchKey = ref('')

const pagination = reactive({
  page: 1,
  pageSize: 20,
  total: 0,
})

const dialogVisible = ref(false)
const dialogMode = ref<'create' | 'edit'>('create')
const formRef = ref()
const formData = reactive<DeviceReadingAgentItem>({
  Id: undefined,
  名称: '',
  提示词: '',
  ISDELETED: true,
})

const formRules = {
  名称: [{ required: true, message: '请输入名称', trigger: 'blur' }],
}

const getResponseData = (res: any) => res?.response || res

const resetForm = () => {
  formData.Id = undefined
  formData.名称 = ''
  formData.提示词 = ''
  formData.ISDELETED = true
}

const fillForm = (data: DeviceReadingAgentItem = {}) => {
  resetForm()
  Object.assign(formData, {
    ...data,
    ISDELETED: Boolean(data.ISDELETED),
  })
}

const loadData = async () => {
  loading.value = true
  try {
    const res: any = await DeviceReadingAgentApi.list(
      {
        page: pagination.page,
        key: searchKey.value,
        intPageSize: pagination.pageSize,
      },
      []
    )
    const response = getResponseData(res)
    tableData.value = Array.isArray(response?.data) ? response.data : []
    pagination.total = Number(response?.dataCount || tableData.value.length || 0)
  } catch (error) {
    console.error('加载设备读数智能体列表失败:', error)
    tableData.value = []
    pagination.total = 0
    ElMessage.error('加载设备读数智能体列表失败')
  } finally {
    loading.value = false
  }
}

const handleSearch = () => {
  pagination.page = 1
  loadData()
}

const handlePageChange = (page: number) => {
  pagination.page = page
  loadData()
}

const handlePageSizeChange = (pageSize: number) => {
  pagination.pageSize = pageSize
  pagination.page = 1
  loadData()
}

const openCreateDialog = () => {
  dialogMode.value = 'create'
  resetForm()
  dialogVisible.value = true
}

const openEditDialog = async (row: DeviceReadingAgentItem) => {
  const id = row.Id ?? row.id
  if (!id) {
    ElMessage.warning('缺少设备读数智能体ID，无法编辑')
    return
  }
  dialogMode.value = 'edit'
  dialogVisible.value = true
  saving.value = false
  try {
    const res: any = await DeviceReadingAgentApi.detail(id)
    const response = getResponseData(res)
    fillForm(response || row)
  } catch (error) {
    console.error('查询设备读数智能体详情失败:', error)
    fillForm(row)
    ElMessage.error('查询详情失败，已使用列表数据')
  }
}

const handleSubmit = () => {
  formRef.value?.validate(async (valid: boolean) => {
    if (!valid) return
    saving.value = true
    try {
      const payload: DeviceReadingAgentItem = {
        ...formData,
        ISDELETED: true,
      }
      const res: any = await DeviceReadingAgentApi.save(payload)
      if (res?.success === false) {
        ElMessage.error(res?.msg || '保存失败')
        return
      }
      ElMessage.success(dialogMode.value === 'create' ? '新增成功' : '更新成功')
      dialogVisible.value = false
      loadData()
    } catch (error) {
      console.error('保存设备读数智能体失败:', error)
      ElMessage.error('保存失败')
    } finally {
      saving.value = false
    }
  })
}

const handleDelete = (row: DeviceReadingAgentItem) => {
  const id = row.Id ?? row.id
  if (!id) {
    ElMessage.warning('缺少设备读数智能体ID，无法删除')
    return
  }
  ElMessageBox.confirm('确认删除该设备读数智能体吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(async () => {
      try {
        const res: any = await DeviceReadingAgentApi.delete(id)
        if (res?.success === false) {
          ElMessage.error(res?.msg || '删除失败')
          return
        }
        ElMessage.success('删除成功')
        loadData()
      } catch (error) {
        console.error('删除设备读数智能体失败:', error)
        ElMessage.error('删除失败')
      }
    })
    .catch(() => {})
}

onMounted(() => {
  loadData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: searchKey.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKey).value = $event)),
          placeholder: "搜索名称或提示词",
          clearable: "",
          class: "search-input",
          "prefix-icon": _unref(Search),
          onKeyup: _withKeys(handleSearch, ["enter"]),
          onClear: handleSearch
        }, null, 8, ["modelValue", "prefix-icon"]),
        _createElementVNode("div", _hoisted_4, [
          (_unref(can)('新增'))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                icon: _unref(Plus),
                onClick: openCreateDialog
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("新增")
                ])),
                _: 1
              }, 8, ["icon"]))
            : _createCommentVNode("", true),
          (_unref(can)('查询'))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                circle: "",
                size: "small",
                class: "app-refresh-btn",
                icon: _unref(Refresh),
                loading: loading.value,
                onClick: loadData,
                title: "刷新"
              }, null, 8, ["icon", "loading"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        border: "",
        stripe: "",
        class: "agent-table",
        height: "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "序号",
            width: "70",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "名称",
            label: "名称",
            "min-width": "180",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "提示词",
            label: "提示词",
            "min-width": "320",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "ISDELETED",
            label: "状态",
            width: "100",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tag, {
                type: row.ISDELETED ? 'danger' : 'success'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.ISDELETED ? '已删除' : '正常'), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }),
          (_unref(canAny)('编辑', '删除'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "操作",
                width: "150",
                fixed: "right",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  (_unref(can)('编辑'))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        link: "",
                        size: "small",
                        icon: _unref(Edit),
                        onClick: ($event: any) => (openEditDialog(row))
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode(" 编辑 ")
                        ])),
                        _: 2
                      }, 1032, ["icon", "onClick"]))
                    : _createCommentVNode("", true),
                  (_unref(can)('删除'))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "danger",
                        link: "",
                        size: "small",
                        icon: _unref(Delete),
                        onClick: ($event: any) => (handleDelete(row))
                      }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode(" 删除 ")
                        ])),
                        _: 2
                      }, 1032, ["icon", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_pagination, {
          "current-page": pagination.page,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((pagination.page) = $event)),
          "page-size": pagination.pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pagination.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          total: pagination.total,
          layout: "total, sizes, prev, pager, next, jumper",
          small: "",
          onSizeChange: handlePageSizeChange,
          onCurrentChange: handlePageChange
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogMode.value === 'create' ? '新增设备读数智能体' : '编辑设备读数智能体',
      width: "640px",
      "close-on-click-modal": false,
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (dialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        (_unref(can)('保存'))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              loading: saving.value,
              onClick: handleSubmit
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("保存")
              ])),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData,
          rules: formRules,
          "label-width": "90px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "名称",
              prop: "名称"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.名称,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.名称) = $event)),
                  placeholder: "请输入名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "提示词",
              prop: "提示词"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.提示词,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.提示词) = $event)),
                  type: "textarea",
                  rows: 8,
                  placeholder: "请输入提示词"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})